import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  SelectFilter,
} from "../../shared/filters/types/filter";
import { getSelectedFilterValue } from "../../shared/filters/utils/filter/filtervalue";

const SORT_BY_START_ID = "sortedByStart";

export function useSortByStartFilter(
  filterValues: FilterValue[]
): SelectFilter {
  const { t } = useTranslation();
  const defaultValue = {
    filterId: SORT_BY_START_ID,
    value: "startAsc",
  };
  const selected = getSelectedFilterValue(
    SORT_BY_START_ID,
    filterValues,
    defaultValue
  );

  const options = [
    { value: "startAsc", title: t("earliestStartString") },
    { value: "startDesc", title: t("latestStartString") },
  ];

  const selectedOption = options.find(
    (option) => option.value === selected.value
  )!;

  return {
    inputType: InputType.Select,
    filterType: FilterType.Sort,
    id: SORT_BY_START_ID,
    title: t("sortByFilterTitleString", { option: selectedOption.title }),
    options,
    enabled: true,
    defaultValue,
  };
}
